import {
    LegacyFilmPlayerBaseInfoContent,
    LegacyVideoPlayerBaseInfoContent,
} from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';

export const useReadFilmPlayerBaseInfo = (
    contentId: string
): LegacyFilmPlayerBaseInfoContent | LegacyVideoPlayerBaseInfoContent | undefined => {
    const data = useReadPlayerBaseInfo(contentId);

    if (data?.content?.__typename === 'Film' || data?.content?.__typename === 'Video') {
        return data.content;
    }

    return undefined;
};
